module.exports = __webpack_public_path__ + "static/media/vector1-2.4b33281c.svg";